angular.module('gym.contacts').controller('EditSuspensionCtrl', ["$scope", "$rootScope", "$state", "$stateParams", "$modal", "$document", "$q", "$window", "$filter", "AllContacts", "loadingAnimation", "MessageService", "flash", "form", "contact", "suspension", function($scope, $rootScope, $state, $stateParams, $modal, $document, $q, $window, $filter, AllContacts, loadingAnimation, MessageService, flash, form, contact, suspension) {
  var checkUnattendedBookings, endMinDate, getMembershipsWithPayments, gym, hasEmptyRemoveBookingsAfterExpiryOptions, initialEndOn, initialStartOn, reloadMembershipsWithPayment, saveSuspension, startMinDate, suspensionErrors;
  $scope.gym = gym = $rootScope.gym;
  $scope.currency = gym.currency_symbol;
  $scope.contact = contact;
  $scope.form = form;
  $scope.suspension = suspension;
  initialStartOn = suspension.start_on;
  initialEndOn = suspension.end_on;
  $scope.units = gym.units;
  $scope.currentStep = 1;
  $scope.isNac = contact.type === 'non_attending_contact';
  $scope.hasActiveMembership = !!_.find(contact.memberships, function(membership) {
    return membership.active;
  });
  startMinDate = moment(gym.today).toDate();
  endMinDate = moment(suspension.start_on).toDate();
  $scope.oneYearFromToday = moment(gym.today).add(365, 'days').toDate();
  $scope.visibleBookings = {};
  $scope.isMobileAppReq = !!$stateParams.mrId;
  suspensionErrors = null;
  $scope.redirectToMembershipInterruptionRequests = function() {
    return $state.go('gym.contacts.membershipInterruptionRequests', {
      contactId: contact.id
    });
  };
  $scope.$watch('isMobileAppReq', function(newValue) {
    if (newValue) {
      $scope.suspension.start_on = $stateParams.startOn;
      $scope.suspension.end_on = $stateParams.endOn;
      return $scope.suspension.reason = $stateParams.reason;
    }
  });
  $scope.$watch('suspension.membership_changes', function(newValue, oldValue) {
    if (newValue) {
      return $scope.oneOffPaymentCheck = Array(newValue.length).fill(false);
    }
  });
  $scope.formatTime = function(time) {
    return moment(time).tz(gym.tz).format('DD MMM YYYY h:mma');
  };
  $scope.isCancellationPending = function(membershipId) {
    var membership, ref;
    membership = _.find(contact.memberships, {
      id: membershipId
    });
    return membership != null ? (ref = membership.membership_cancellation) != null ? ref.id : void 0 : void 0;
  };
  $scope.getMinDate = function(field) {
    if (field === 'start_on') {
      return startMinDate;
    }
    if (field === 'end_on') {
      return endMinDate;
    }
  };
  checkUnattendedBookings = function() {
    var deferred, params;
    deferred = $q.defer();
    params = {
      'filters[starts_after]': $scope.suspension.start_on,
      'filters[starts_before]': $scope.suspension.end_on
    };
    contact.all('bookings').all('unattended').getList(params).then(function(bookings) {
      var modalInstance;
      if (bookings.length) {
        modalInstance = $modal.open({
          template: require('templates/gyms/contacts/suspensions/confirmation.html.slim'),
          resolve: {
            bookings: function() {
              return bookings.plain();
            }
          },
          controller: ["$scope", "$modalInstance", "bookings", function($scope, $modalInstance, bookings) {
            $scope.bookings = bookings;
            $scope.submit = function() {
              return $modalInstance.close();
            };
            return $scope.cancel = function() {
              return $modalInstance.dismiss('cancel');
            };
          }]
        });
        return modalInstance.result.then(function() {
          return deferred.resolve();
        }, function(reason) {
          return deferred.reject(reason);
        });
      } else {
        return deferred.resolve();
      }
    });
    return deferred.promise;
  };
  saveSuspension = function() {
    var req;
    $scope.suspension.rootObjectName = 'contact_suspension';
    if ($scope.isMobileAppReq) {
      $scope.suspension.membership_interruption_request_id = Number($stateParams.mrId);
    }
    req = $scope.suspension.id ? contact.one('suspensions', $scope.suspension.id).doPUT($scope.suspension) : contact.all('suspensions').doPOST($scope.suspension);
    return req.then(function(resp) {
      if ($scope.isMobileAppReq) {
        $scope.$emit('contacts:states:reload');
      }
      return resp;
    });
  };
  getMembershipsWithPayments = function() {
    var params;
    params = {
      'filters[suspension_starts_on]': $scope.suspension.start_on,
      'filters[suspension_ends_on]': $scope.suspension.end_on,
      'filters[contact_suspension_id]': $scope.suspension.id
    };
    return AllContacts().one($stateParams.contactId).all('memberships_with_payments').getList(params);
  };
  $scope.showPayments = function(membership) {
    return $modal.open({
      template: require('templates/gyms/contacts/suspensions/show_payments.html.slim'),
      resolve: {
        payments: function() {
          return membership.payments_affected;
        },
        currency: function() {
          return $scope.currency;
        }
      },
      controller: ["$scope", "$modalInstance", "payments", "currency", function($scope, $modalInstance, payments, currency) {
        $scope.payments = payments;
        $scope.currency = currency;
        $scope.submit = function() {
          return $modalInstance.close();
        };
        return $scope.cancel = function() {
          return $modalInstance.dismiss('cancel');
        };
      }]
    });
  };
  $scope.cancelSubmittedPayments = function(membership, membershipIndex) {
    var confirmMessage, ids, params, paymentsCount;
    ids = _.filter(membership.payments_affected, {
      status: 'Submitted'
    }).map(function(item) {
      return item.id;
    });
    paymentsCount = $filter('pluralize')('payment', ids.length, true);
    confirmMessage = `${paymentsCount} will be cancelled. Are you sure?`;
    if ($window.confirm(confirmMessage)) {
      loadingAnimation.show();
      params = {
        withoutNamespace: true,
        invoice_ids: ids
      };
      return contact.all('memberships_with_payments').doPOST(params, 'cancel_submitted_invoices').then(function(response) {
        reloadMembershipsWithPayment(membershipIndex);
        return loadingAnimation.hide();
      }, function() {
        var message;
        loadingAnimation.hide();
        message = 'An error occurred cancelling submitted payments. Please contact your payment provider to stop these payments.';
        return flash.error = message;
      });
    }
  };
  $scope.bookingsAfterNewExpirySelectVisible = function(membership) {
    return $scope.getMembershipExpiryStatus(membership) === 'expiry_reduced' && membership.bookings_scheduled_after_expiry.length;
  };
  hasEmptyRemoveBookingsAfterExpiryOptions = function() {
    return _.find($scope.membershipsWithPayments, function(membership, index) {
      return $scope.bookingsAfterNewExpirySelectVisible(membership) && $scope.suspension.membership_changes[index].remove_bookings_after_expiry === void 0;
    });
  };
  $scope.save = function() {
    $scope.isLoading = true;
    return checkUnattendedBookings().then(function() {
      return saveSuspension().then(function(response) {
        var data, success;
        $scope.isLoading = false;
        data = (response != null ? response.data : void 0) || response;
        success = false;
        if (data != null) {
          if (data.success != null) {
            success = !!data.success;
          } else if (data.id != null) {
            success = true;
          } else if (_.isObject(data.errors)) {
            success = _.isEmpty(data.errors);
          }
        }
        if (success) {
          if ($scope.isMobileAppReq) {
            flash.success = 'Suspension request approved';
            $scope.redirectToMembershipInterruptionRequests();
          } else {
            flash.success = 'Suspension saved';
            $state.go('gym.contacts.edit', {
              contactId: contact.id
            });
          }
          return;
        }
        if ($scope.isMobileAppReq) {
          $scope.goToFirstStep();
          return;
        }
        if ((suspensionErrors != null ? suspensionErrors.start_on : void 0) || (suspensionErrors != null ? suspensionErrors.end_on : void 0)) {
          $scope.goToFirstStep();
        }
        return flash.error = 'Save failed. Please fix the errors below';
      }, function(response) {
        var hasOverlap, overlapMsg, ref, ref1, ref2;
        $scope.isLoading = false;
        $scope.suspension.errors = (response != null ? (ref = response.data) != null ? ref.errors : void 0 : void 0) || {};
        suspensionErrors = response != null ? (ref1 = response.data) != null ? (ref2 = ref1.errors) != null ? ref2.suspension : void 0 : void 0 : void 0;
        overlapMsg = 'start/end dates overlap with another suspension for this contact';
        hasOverlap = !!((suspensionErrors != null ? suspensionErrors.start_on : void 0) && suspensionErrors.start_on.indexOf(overlapMsg) !== -1);
        if ($scope.isMobileAppReq && hasOverlap) {
          $scope.goToFirstStep();
          flash.error = 'Save failed. Please fix the errors below';
          return;
        }
        if ((suspensionErrors != null ? suspensionErrors.start_on : void 0) || (suspensionErrors != null ? suspensionErrors.end_on : void 0)) {
          $scope.goToFirstStep();
        }
        return flash.error = 'Save failed. Please fix the errors below';
      });
    }, function() {
      return $scope.isLoading = false;
    });
  };
  $scope.openSuspensionInfoModal = function() {
    return MessageService.message({
      title: 'Suspension Information',
      message: `<strong>Please be aware of the following when suspending members:</strong>
<ol style="padding-left:1.2em; margin:0;">
  <li>Adding a suspension will stop payments and bookings (by the member) for the period of the suspension.</li>
  <li>Any payments that fall within the suspension period will be pushed out and added to the end of the membership, ensuring the full membership amount is still collected.</li>
  <li>If your member has more than one active membership, the suspension will affect all of them.</li>
  <li>Suspension periods are inclusive of the start and end date.</li>
</ol>`,
      bindHtml: true
    });
  };
  reloadMembershipsWithPayment = function(membershipIndex) {
    return getMembershipsWithPayments().then(function(response) {
      var membership, suspensionChange;
      $scope.membershipsWithPayments = response.plain();
      membership = $scope.membershipsWithPayments[membershipIndex];
      suspensionChange = $scope.suspension.membership_changes[membershipIndex];
      if (!membership.payments_affected.length) {
        suspensionChange.suspension_action = 'no_payments_affected';
        if (membership.infinite) {
          return suspensionChange.extend_membership_expiry = true;
        }
      }
    });
  };
  $scope.continue = function() {
    $scope.isLoading = true;
    return getMembershipsWithPayments().then(function(response) {
      $scope.isLoading = false;
      $scope.membershipsWithPayments = response.plain();
      $document.scrollTop(0);
      $scope.currentStep = 2;
      return $scope.suspension.membership_changes = $scope.membershipsWithPayments.map(function(membership) {
        var ref, suspensionChange;
        suspensionChange = {
          membership_id: membership.id,
          extend_membership_expiry: false
        };
        if ($scope.isCancellationPending(membership.id)) {
          suspensionChange.suspension_action = 'move_payments_to_end';
        }
        if (!membership.payments_affected.length) {
          suspensionChange.suspension_action = 'no_payments_affected';
        }
        if (membership.payment_plan_version === 'v2_invoice_plan') {
          suspensionChange.suspension_action = !(membership != null ? (ref = membership.payments_affected) != null ? ref.length : void 0 : void 0) ? 'no_payments_affected' : membership.expiration_date != null ? 'move_payments_to_end' : 'delete_without_catch_up';
        }
        if (membership.infinite) {
          suspensionChange.extend_membership_expiry = true;
        }
        return suspensionChange;
      });
    });
  };
  $scope.getMembershipExpiryStatus = function(membership) {
    var durationChanged, expiryExtended;
    if (!suspension.membership_expiries_extended) {
      return;
    }
    durationChanged = moment($scope.suspension.end_on).diff($scope.suspension.start_on, 'days') !== moment(initialEndOn).diff(initialStartOn, 'days');
    expiryExtended = suspension.membership_expiries_extended[membership.id] !== false;
    switch (false) {
      case !membership.infinite:
        return 'does_not_expire';
      case !!durationChanged:
        return 'suspension_duration_unchanged';
      case !(durationChanged && !expiryExtended):
        return 'expiry_unchanged';
      case !(moment($scope.suspension.end_on).diff($scope.suspension.start_on, 'days') > moment(initialEndOn).diff(initialStartOn, 'days') && expiryExtended):
        return 'expiry_extended';
      case !(moment($scope.suspension.end_on).diff($scope.suspension.start_on, 'days') < moment(initialEndOn).diff(initialStartOn, 'days') && expiryExtended):
        return 'expiry_reduced';
    }
  };
  $scope.onRemoveBookingsChange = function(membership, index) {
    return $scope.suspension.membership_changes[index].booking_ids_to_delete = $scope.suspension.membership_changes[index].remove_bookings_after_expiry ? membership.bookings_scheduled_after_expiry.map(function(item) {
      return item.id;
    }) : void 0;
  };
  $scope.onSuspensionActionChangedV2MembershipPlan = function(index) {
    var membership, membershipChange, ref;
    membershipChange = $scope.suspension.membership_changes[index];
    membership = $scope.membershipsWithPayments[index];
    if ($scope.oneOffPaymentCheck[index] === true) {
      membership = $scope.membershipsWithPayments[index];
      membershipChange.catchup_payment_amount = parseFloat(membership.total_amount_affected);
      membershipChange.catchup_payment_days_after = 1;
      return membershipChange.suspension_action = 'delete_with_catch_up_payment';
    } else {
      membershipChange.catchup_payment_amount = void 0;
      membershipChange.catchup_payment_days_after = void 0;
      return membershipChange.suspension_action = !(membership != null ? (ref = membership.payments_affected) != null ? ref.length : void 0 : void 0) ? 'no_payments_affected' : membership.expiration_date != null ? 'move_payments_to_end' : 'delete_without_catch_up';
    }
  };
  $scope.onSuspensionActionChanged = function(index) {
    var membership, membershipChange;
    membershipChange = $scope.suspension.membership_changes[index];
    if (membershipChange.suspension_action === 'delete_with_catch_up_payment') {
      membership = $scope.membershipsWithPayments[index];
      membershipChange.catchup_payment_amount = parseFloat(membership.total_amount_affected);
      return membershipChange.catchup_payment_days_after = 1;
    } else {
      membershipChange.catchup_payment_amount = void 0;
      return membershipChange.catchup_payment_days_after = void 0;
    }
  };
  $scope.cancel = function() {
    if ($scope.isMobileAppReq) {
      $scope.redirectToMembershipInterruptionRequests();
      return;
    }
    return $state.go('gym.contacts.edit', {
      contactId: contact.id
    });
  };
  $scope.isFirstStepReady = function() {
    return !$scope.isLoading && $scope.suspension.start_on && $scope.suspension.end_on && $scope.isStartDateValid() && $scope.isEndDateValid();
  };
  $scope.isStartDateValid = function() {
    var date, gymToday;
    date = moment($scope.suspension.start_on);
    gymToday = moment.tz(gym.today, gym.tz);
    return ($scope.suspension.id || date.isSameOrAfter(gymToday, 'day')) && date.isSameOrBefore($scope.oneYearFromToday, 'day');
  };
  $scope.getStartDateError = function() {
    var date, gymToday;
    if (!$scope.suspension.start_on) {
      return null;
    }
    date = moment($scope.suspension.start_on);
    gymToday = moment.tz(gym.today, gym.tz);
    if (!$scope.suspension.id && date.isBefore(gymToday, 'day')) {
      return 'too_early';
    } else if (date.isAfter($scope.oneYearFromToday, 'day')) {
      return 'too_late';
    } else {
      return null;
    }
  };
  $scope.isEndDateValid = function() {
    var endDate, endDateMoment, gymToday, startDate;
    startDate = $scope.suspension.start_on;
    endDate = $scope.suspension.end_on;
    gymToday = moment.tz(gym.today, gym.tz);
    endDateMoment = moment(endDate);
    return endDateMoment.isSameOrAfter(startDate, 'day') && endDateMoment.isSameOrBefore($scope.oneYearFromToday, 'day');
  };
  $scope.getEndDateError = function() {
    var endDate, gymToday, startDate;
    if (!$scope.suspension.end_on) {
      return null;
    }
    startDate = $scope.suspension.start_on;
    endDate = moment($scope.suspension.end_on);
    gymToday = moment.tz(gym.today, gym.tz);
    if (endDate.isAfter($scope.oneYearFromToday, 'day')) {
      return 'too_late';
    } else if (startDate && endDate.isBefore(moment(startDate), 'day')) {
      return 'before_start';
    } else {
      return null;
    }
  };
  $scope.isSecondStepReady = function() {
    return !$scope.isLoading;
  };
  $scope.isStartDateDisabled = function() {
    var gymToday;
    gymToday = moment.tz(gym.today, gym.tz);
    return $scope.suspension.id && moment($scope.suspension.start_on).isSameOrBefore(gymToday, 'day');
  };
  $scope.isFieldDisabled = function(field) {
    switch (field.name) {
      case 'start_on':
        return $scope.isStartDateDisabled();
    }
  };
  return $scope.goToFirstStep = function() {
    $document.scrollTop(0);
    return $scope.currentStep = 1;
  };
}]);
